<template>
  <div
    class="arrow-down scroll-down-button"
    id="scroll-btn"
    @click="handleClickScrool()"
    :class="{ active: isScrollVisible }"
  >
    <img :src="slide" class="slide__down--button scroll-down-button"/>
  </div>
</template>
<script>
import Slide from '@/assets/images/slide.png';

export default {
  name: 'SlideDown',

  data() {
    return {
      isScrollVisible: false,
    };
  },
  computed: {
    slide() {
      return Slide;
    },
  },
  mounted() {
    this.handleToggleScroll();
  },
  created() {
    window.addEventListener('scroll', this.handleToggleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleToggleScroll);
  },
  methods: {
    bottomWindowFromStart() {
      const topWindowFromStart = window.scrollY;
      const windowHeight = window.innerHeight;
      return topWindowFromStart + windowHeight;
    },
    handleClickScrool() {
      const items = [...document.querySelectorAll('.material-item')];

      const target = items.find((item) => {
        const itemDetails = item.getBoundingClientRect();
        const bottomItemFromStart = window.scrollY + itemDetails.bottom;
        if (bottomItemFromStart > this.bottomWindowFromStart()) return item;
        return false;
      });
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    },
    handleToggleScroll() {
      const items = [...document.querySelectorAll('.material-item')];
      const lastItem = items[items.length - 1];
      if (lastItem) {
        const itemDetails = lastItem.getBoundingClientRect();
        const bottomItemFromStart = window.scrollY + itemDetails.bottom;
        if (
          this.bottomWindowFromStart() > bottomItemFromStart
          && this.isScrollVisible === true
        ) {
          this.isScrollVisible = false;
        } else if (
          this.bottomWindowFromStart() < bottomItemFromStart
          && this.isScrollVisible === false
        ) {
          this.isScrollVisible = true;
        }
      }
    },
  },
};
</script>
<style lang="scss">
.arrow-down {
  display: none;
  position: fixed;
  bottom: 117px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  opacity: 0;
  overflow: hidden;
  visibility: hidden;
  transition: 0.3s;
  &:hover{
    transform: translateX(-50%) scale(1.08);
  }
  img{
    border-radius: 100%;
  }
  @media screen and (max-width: 991px) {
    display: block;
  }
}
.arrow-down.active {
  opacity: 1;
  visibility: visible;
  overflow: visible;
}
</style>
